window.showGeolocationModal = function(modalId) {

  const modal = document.getElementById(modalId);
  
  GeoLocationModalWireUpOutsideClick(modal);

  modal.showModal();

}

function CheckGeoLocationCheck()
{

  if(HasLocalStorageGeoLocation())
  {
    console.log("CheckGeoLocationCheck has already been run");
    return;
  }
  
  fetch('https://api.ipgeolocation.io/ipgeo')
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        console.error('Geo Location Network response was Bad');
      }
    })
    .then(data => CheckForLoadGeoLocationModal(data))
    .catch(error => console.error('Error:', error));
}

function HasLocalStorageGeoLocation()
{
    if(localStorage.getItem('nwGeoData'))
      return true;

  return false;
}

function CheckForLoadGeoLocationModal(data)
{
  console.log('CheckForLoadGeoLocationModal');
  //console.log(data);

  localStorage.setItem('nwGeoData', JSON.stringify(data));
  
  if(data.country_code3 == "USA")
  {
    return;
  }
  if(data.country_code3 == "CAN")
  {
    GeoLocationModalLoadCanada();
    return;
  }

  //all else iHerb display
  GeoLocationModalLoadIherb();
}

function GeoLocationModalLoadIherb()
{
  console.log('location international display iHerb modal');
  window.showGeolocationModal('geolocationModal-iherb');

}

function GeoLocationModalLoadCanada()
{
  console.log('location CAN display Canada modal');
  window.showGeolocationModal('geolocationModal-CA');
}

function GeoLocationModalWireUpOutsideClick(dialog)
{
    dialog.addEventListener('click', (event) => {
        if (event.target === dialog) {
            dialog.close();
        }
    });    

    // Close button
    document.addEventListener('click', (event) => {
        const btn = event.target.closest('.geo-modal-close');

        if (btn) {
            btn.closest('dialog')?.close();
        }
    });
}

window.addEventListener('load', function() {
    // Only add event listener, and do geolocation logic, 
    // if the user has already consented to privacy policies.
    // Preferences for storing geolocation choice,
    // marketing/sharing of data for calling for country based on IP

    // Get the current consent values
    const preferences   = window.Shopify.customerPrivacy.preferencesProcessingAllowed();
    const marketing     = window.Shopify.customerPrivacy.marketingAllowed();
    const saleOfData    = window.Shopify.customerPrivacy.saleOfDataAllowed();    

    if (preferences && marketing && saleOfData)
    {
        CheckGeoLocationCheck();
    }
    else
    {
        // No consent for geolocation
    }
});

